import { goRequest as request } from '../utils/httpClientTs';
import {
  IntroductionForm,
  IntroductionListResponse,
  IntroductionCreateRequest,
  IntroductionUpdateRequest,
  IntroductionChapterAdd,
  IntroductionSearchParams,
} from '../types/introduction';

export const getIntroductions = async (
  params: IntroductionSearchParams
): Promise<IntroductionListResponse> => {
  const response = await request({
    url: '/introductions',
    method: 'GET',
    params,
  });
  return response;
};

export const getIntroduction = async (
  id: string
): Promise<IntroductionForm> => {
  const response = await request({
    url: `/introductions/${id}`,
    method: 'GET',
  });
  return response;
};

export const createIntroduction = async (
  data: IntroductionCreateRequest
): Promise<{ message: string }> => {
  const response = await request({
    url: '/introductions',
    method: 'POST',
    data,
  });
  return response;
};

export const updateIntroduction = async (
  id: string,
  data: IntroductionUpdateRequest
): Promise<{ message: string }> => {
  const response = await request({
    url: `/introductions/${id}`,
    method: 'PUT',
    data,
  });
  return response;
};

export const deleteIntroduction = async (
  id: string
): Promise<{ message: string }> => {
  const response = await request({
    url: `/introductions/${id}`,
    method: 'DELETE',
  });
  return response;
};

export const addChapterToIntroduction = async (
  id: string,
  data: IntroductionChapterAdd
): Promise<{ message: string }> => {
  const response = await request({
    url: `/introductions/${id}/chapters`,
    method: 'POST',
    data,
  });
  return response;
};
